import React from 'react';
import { socialLinks } from '../data/site';

function JoinUsSection() {
  return (
    <section className="kg-section kg-community">
      <h2 className="kg-section-heading">Come Join Us</h2>
      <p className="kg-community-text">
        Follow Kaddera Games for devlogs, trailers, and new release announcements.
      </p>
      <div className="kg-community-links">
        {socialLinks.map((social) => (
          <a
            key={social.platform}
            href={social.href}
            className="kg-community-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {social.label}
          </a>
        ))}
      </div>
    </section>
  );
}

export default JoinUsSection;
